import { IDeclineServiceProviderParams, IToastProps } from "../types";
import { declineServiceProviderService } from "../services/candidates";
import { SERVICE_REQUEST_CANDIDATES_QUERY_KEY } from "./useCandidates";
import useI18n from "@I18n/hooks/useI18n";
import messages from "../Components/messages";
import { useDataQueryClient } from "@Libs/DataLayer/hooks/useDataQuery";
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";

// this will decline SPs after they made an offer or send a message.
// this will allow other SPs to apply since there is a max SPs allowed to apply for a single task
export const useDeclineServiceProvider = (showToast: IToastProps) => {
  const queryClient = useDataQueryClient();

  const { formatMessage } = useI18n();

  const {
    mutate: declineServiceProvider,
    isLoading,
    isSuccess,
    isError,
  } = useDataMutation(
    (params: IDeclineServiceProviderParams) =>
      declineServiceProviderService(params),
    {
      onSuccess: (_, variables) => {
        setTimeout(
          () =>
            queryClient.invalidateQueries([
              SERVICE_REQUEST_CANDIDATES_QUERY_KEY,
            ]),
          500
        );
        showToast({
          status: "success",
          description: formatMessage(
            messages["serviceRequest.declineOffer.successful_decline"],
            { serviceProviderName: variables.serviceProviderName }
          ),
        });
      },
      onError: (_, variables) => {
        showToast({
          status: "error",
          description: formatMessage(
            messages["serviceRequest.declineOffer.error_while_declining"],
            { serviceProviderName: variables.serviceProviderName }
          ),
        });
      },
    }
  );

  return {
    declineServiceProvider,
    isLoading,
    isSuccess,
    isError,
  };
};
